define([
    "jquery",
    "underscore",
    "marionette",
    "behaviors/form_errors_behavior",
    "backbone.syphon",
    "holdon"
], function($, _, Marionette, FormErrorsBehavior) {
    return Marionette.View.extend({
        el: '#content_layout',

        ui:{
            'submitBtn': '#submit_btn'
        },

        events:{
            'click @ui.submitBtn': 'submit'
        },

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            }
        },

        initialize: function(){
            this.bindUIElements();
        },
                
        submit: function(e){
            var that = this;
            if(e) e.preventDefault();

            const selectedServer = $('#server').val();
            if(selectedServer === 'demo') {
                window.open($('#demo_mt5_webterminal_url').val(), '_blank');
                return;
            }else if(selectedServer === 'live'){
                window.open($('#live_mt5_webterminal_url').val(), '_blank');
                return;
            }

            alert('Please Choose a server in the options');
            return;
        }
    });
});